module.exports = __webpack_public_path__ + "static/embark_cover-f40cbc58762be00f95db335d0793aa15.png";